import { MixpanelEvent } from 'shared/utils/mixpanel/mixpanel.types';

import { isProduction, isStaging, isUat, isDev } from '../env';

const PROJECT_TOKEN = import.meta.env.REACT_APP_MIXPANEL_TOKEN;
const isJest = !!import.meta.env.JEST_WORKER_ID;
const shouldEnableMixpanel =
  PROJECT_TOKEN &&
  !isJest &&
  (isProduction ||
    isStaging ||
    isUat ||
    import.meta.env.REACT_APP_MIXPANEL_FORCE_ENABLE === 'true');

export const Mixpanel = {
  init() {
    if (shouldEnableMixpanel) {
      import('mixpanel-browser').then(({ default: mixpanel }) => {
        mixpanel.init(PROJECT_TOKEN, { ignore_dnt: isDev });
      });
    }
  },
  trackPageView(pageName: string) {
    if (shouldEnableMixpanel) {
      import('mixpanel-browser').then(({ default: mixpanel }) => {
        mixpanel.track_pageview({ page: `[Admin] ${pageName}` });
      });
    }
  },
  track(event: MixpanelEvent) {
    if (shouldEnableMixpanel) {
      import('mixpanel-browser').then(({ default: mixpanel }) => {
        const { action, ...properties } = event;
        mixpanel.track(`[Admin] ${action}`, properties);
      });
    }
  },
  login(userId: string) {
    if (shouldEnableMixpanel) {
      import('mixpanel-browser').then(({ default: mixpanel }) => {
        mixpanel.identify(userId);
        mixpanel.people.set({
          'User ID': userId,
          'App Build Number': import.meta.env.REACT_APP_DEVELOP_BUILD_VERSION,
        });
      });
    }
  },
  logout() {
    if (shouldEnableMixpanel) {
      import('mixpanel-browser').then(({ default: mixpanel }) => {
        mixpanel.reset();
      });
    }
  },
  updateProfile(userId: string | undefined, properties: Record<string, unknown>) {
    if (shouldEnableMixpanel) {
      import('mixpanel-browser').then(({ default: mixpanel }) => {
        if (userId) {
          mixpanel.identify(userId);
        } else {
          console.warn('[Mixpanel] updateProfile called without userId - profile may not update');
        }
        mixpanel.people.set(properties);
      });
    }
  },
};
